export default __webpack_public_path__ + "static/61617800_694744934289636_2771704187793481806_n-5d70bf18c4aa1bf788a0c3315cbee8c7.jpg";